import { get } from "lodash";
import { TOTAL_RETAIL } from "./formula-total-retail";
import { MetricsKind } from "../types";
import { referenceMetricValueOrCompute, sumColumnValues } from "../sibling-value-getter/getter";
import { safeParseFloat } from "lib/number";
import { BULK_IDENTIFIER } from "components/product-collection/product-collection-views/product-collection-grid-view/detail-list/helpers";

export const ROW_PERCENTAGE_PLAN = ({ factoryOptions, getterParams }) => {
    if (factoryOptions.useSize || get(getterParams, "node.data.type") === BULK_IDENTIFIER) {
        return undefined;
    }

    const totalRetailColumnValuesSum = sumColumnValues(MetricsKind.TOTAL_RETAIL, factoryOptions, getterParams);
    const currentRetail = referenceMetricValueOrCompute(
        () => safeParseFloat(TOTAL_RETAIL({ factoryOptions, getterParams }), 0),
        getterParams,
        MetricsKind.TOTAL_RETAIL
    );

    if (totalRetailColumnValuesSum > 0 && currentRetail) {
        return (currentRetail / totalRetailColumnValuesSum) * 100;
    }

    return 0;
};
